import { CustomCodeManager } from '@carboncopyco/editor-ui';
import { addFSToken } from '@carboncopyco/editor-utils';
import { memo } from 'react';
import { useEditor, useEditorCodeSnippets } from '../context/EditorSdkProvider';
import { useEditorTool } from '../hooks/useEditorTool';

export type CustomCodeToolProps = {
  fsToken?: string;
};

export const CustomCodeTool = memo(({ fsToken = '' }: CustomCodeToolProps) => {
  const { isOpen, close } = useEditorTool('customCode');

  const editorSdk = useEditor();
  const {
    snippets,
    createCodeSnippet,
    editCodeSnippet,
    deleteCodeSnippet,
    reorderCodeSnippets,
  } = useEditorCodeSnippets();

  return (
    <CustomCodeManager
      isOpen={isOpen}
      onClose={close}
      snippets={snippets.map((snippet) => ({
        ...snippet,
        source: addFSToken(snippet.source, fsToken),
      }))}
      onLearnMoreClick={editorSdk.openUrlLink}
      updateSnippet={editCodeSnippet}
      deleteSnippet={deleteCodeSnippet}
      createSnippet={createCodeSnippet}
      reorderSnippets={reorderCodeSnippets}
    />
  );
});

CustomCodeTool.displayName = 'CustomCodeTool';
